import { AccountProvider } from '@/context/account.context';

const withAccount = (props) => {
  return <AccountProvider>{props.children}</AccountProvider>;
};

export default withAccount;
